import React, { useState } from 'react';
import video from '../images/video.mp4';
const Main = ({ 
  sposo = "Gianluca", 
  sposa = "Pamela", 
  fotoUrl = null,
  // Nota: Ho lasciato questa prop ma ora usiamo l'URL del video hardcoded o passato come preferisci
  fotoLocationUrl = null, 
  data = "16 Maggio 2026",
  ora = "XX.XX",
  location = "Le 7 Fonti",
  indirizzo = "Via Prato della Corte 275, Roma",
  hotels = [],
  onConferma = null
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isAccommodationOpen, setIsAccommodationOpen] = useState(false);
  
  // URL del video fornito
  const videoLocationUrl = video;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&family=Josefin+Sans:wght@200;300;400&display=swap');

        .wedding-main {
          /* Nuova palette */
          --dusty-blue: #c3e5ea;
          --dusty-blue-light: #e8ebe6;
          --dusty-blue-dark: #a8d5dd;
          --dusty-blue-deeper: #8ac4d0;
          --cream: #ffffff;
          --cream-warm: #fdfcfb;
          --gold: #f6cdca;
          --gold-light: #f6cdca;
          --text-dark: #3a4a5c;
          --text-soft: #5a6a7c;

          font-family: 'Josefin Sans', sans-serif;
          background: var(--cream-warm);
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          overflow-x: hidden;
          position: relative;
          padding: 40px 20px;
        }

        .wedding-main * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        /* Animated Background */
        .bg-gradient {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background:
            radial-gradient(ellipse at 20% 10%, rgba(195, 229, 234, 0.2) 0%, transparent 50%),
            radial-gradient(ellipse at 80% 90%, rgba(246, 205, 202, 0.15) 0%, transparent 50%),
            radial-gradient(ellipse at 50% 50%, rgba(232, 235, 230, 0.1) 0%, transparent 60%),
            var(--cream-warm);
          z-index: 0;
        }

        /* Floating Petals */
        .petals {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          overflow: hidden;
          z-index: 1;
        }

        .petal {
          position: absolute;
          width: 12px;
          height: 18px;
          background: var(--dusty-blue);
          border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
          opacity: 0;
          animation: petalFall linear infinite;
          pointer-events: none; /* FIX: Prevents scroll blocking */
        }

        .petal:nth-of-type(1) { left: 5%; animation-duration: 12s; background: var(--gold); }
        .petal:nth-of-type(2) { left: 15%; animation-duration: 14s; animation-delay: 2s; background: var(--dusty-blue); }
        .petal:nth-of-type(3) { left: 25%; animation-duration: 11s; animation-delay: 4s; background: var(--dusty-blue-light); width: 11px; height: 16px; }
        .petal:nth-of-type(4) { left: 40%; animation-duration: 15s; animation-delay: 1s; background: var(--gold); width: 10px; height: 14px; }
        .petal:nth-of-type(5) { left: 55%; animation-duration: 13s; animation-delay: 3s; background: var(--dusty-blue); }
        .petal:nth-of-type(6) { left: 70%; animation-duration: 12s; animation-delay: 5s; background: var(--gold-light); width: 13px; height: 17px; }
        .petal:nth-of-type(7) { left: 85%; animation-duration: 14s; animation-delay: 2.5s; background: var(--dusty-blue-light); }
        .petal:nth-of-type(8) { left: 95%; animation-duration: 11s; animation-delay: 6s; background: var(--gold); width: 11px; height: 15px; }

        @keyframes petalFall {
          0% { top: -20px; opacity: 0; transform: rotate(0deg) translateX(0); }
          10% { opacity: 0.6; }
          90% { opacity: 0.6; }
          100% { top: 100vh; opacity: 0; transform: rotate(360deg) translateX(30px); }
        }

        /* Corner Decorations */
        .corner-decor {
          position: fixed;
          width: 120px;
          height: 120px;
          opacity: 0.5;
          z-index: 2;
        }

        .corner-decor.top-left { top: 20px; left: 20px; }
        .corner-decor.top-right { top: 20px; right: 20px; transform: scaleX(-1); }
        .corner-decor.bottom-left { bottom: 20px; left: 20px; transform: scaleY(-1); }
        .corner-decor.bottom-right { bottom: 20px; right: 20px; transform: scale(-1); }

        /* Main Card */
        .save-the-date-card {
          position: relative;
          z-index: 10;
          display: flex;
          flex-direction: column;
          align-items: center;
          max-width: 500px;
          width: 100%;
          animation: cardFadeIn 1s ease-out;
        }

        @keyframes cardFadeIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* Header */
        .header-text {
          font-family: 'Josefin Sans', sans-serif;
          font-size: 12px;
          font-weight: 200;
          letter-spacing: 8px;
          text-transform: uppercase;
          color: var(--dusty-blue-deeper);
          margin-bottom: 30px;
          animation: fadeInUp 1s ease-out 0.2s both;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* Photo Section */
        .photo-section {
          position: relative;
          margin-bottom: 40px;
          animation: fadeInUp 1s ease-out 0.4s both;
        }

        .photo-frame {
          position: relative;
          width: 220px;
          height: 220px;
          border-radius: 50%;
          padding: 6px;
          background: linear-gradient(135deg, var(--gold) 0%, #f4beb8 50%, var(--gold) 100%);
          box-shadow:
            0 20px 50px rgba(246, 205, 202, 0.5),
            0 8px 25px rgba(0, 0, 0, 0.1);
        }

        .photo-inner {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: linear-gradient(145deg, var(--dusty-blue-light) 0%, var(--dusty-blue) 100%);
          border: 4px solid var(--cream);
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .photo-inner img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .photo-placeholder {
          color: var(--cream);
          opacity: 0.9;
        }

        /* Decorative Ring */
        .decorative-ring {
          position: absolute;
          top: -15px;
          left: -15px;
          right: -15px;
          bottom: -15px;
          border-radius: 50%;
          border: 1.5px solid var(--dusty-blue);
          opacity: 0.6;
          animation: ringRotate 20s linear infinite;
        }

        .decorative-ring::before {
          content: '';
          position: absolute;
          top: 50%;
          left: -4px;
          width: 8px;
          height: 8px;
          background: var(--gold);
          border-radius: 50%;
          transform: translateY(-50%);
        }

        .decorative-ring::after {
          content: '';
          position: absolute;
          top: 50%;
          right: -4px;
          width: 8px;
          height: 8px;
          background: var(--gold);
          border-radius: 50%;
          transform: translateY(-50%);
        }

        @keyframes ringRotate {
          to { transform: rotate(360deg); }
        }

        /* Tulip Decorations */
        .tulip {
          position: absolute;
          z-index: 5;
        }

        .tulip-left {
          left: -80px;
          top: 50%;
          transform: translateY(-50%);
          animation: tulipSway 4s ease-in-out infinite;
        }

        .tulip-right {
          right: -80px;
          top: 50%;
          transform: translateY(-50%);
          animation: tulipSway 4s ease-in-out infinite reverse;
        }

        @keyframes tulipSway {
          0%, 100% { transform: translateY(-50%) rotate(-2deg); }
          50% { transform: translateY(-50%) rotate(2deg); }
        }

        /* Names */
        .names {
          font-family: 'Cormorant Garamond', serif;
          display: flex;
          align-items: center;
          gap: 20px;
          font-size: 52px;
          font-weight: 300;
          font-style: italic;
          color: var(--text-dark);
          text-align: center;
          line-height: 1.1;
          margin-bottom: 25px;
          animation: fadeInUp 1s ease-out 0.6s both;
        }

        .ampersand {
          display: block;
          font-size: 32px;
          color: var(--gold);
          font-style: normal;
          margin: 5px 0;
        }

        /* Divider */
        .divider {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 30px;
          animation: fadeInUp 1s ease-out 0.7s both;
        }

        .divider-line {
          width: 60px;
          height: 1px;
          background: linear-gradient(90deg, transparent, var(--dusty-blue), transparent);
        }

        .divider-icon {
          color: var(--gold);
          font-size: 14px;
        }

        /* Location Photo Section */
        .location-section {
          width: 100%;
          max-width: 600px;
          margin-bottom: 35px;
          animation: fadeInUp 1s ease-out 0.75s both;
        }

        .location-photo-frame {
          position: relative;
          width: 100%;
          height: 260px;
          border-radius: 12px;
          padding: 4px;
          background: linear-gradient(135deg, var(--dusty-blue) 0%, var(--dusty-blue-dark) 50%, var(--dusty-blue) 100%);
          box-shadow:
            0 15px 40px rgba(195, 229, 234, 0.4),
            0 5px 15px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }

        .location-photo-inner {
          width: 100%;
          height: 100%;
          border-radius: 10px;
          background: linear-gradient(145deg, var(--dusty-blue-light) 0%, var(--dusty-blue) 100%);
          overflow: hidden;
          position: relative;
        }

        /* AGGIORNATO: Ora targettiamo sia img che video */
        .location-photo-inner img, 
        .location-photo-inner video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s ease;
          display: block;
        }

        .location-photo-frame:hover .location-photo-inner img,
        .location-photo-frame:hover .location-photo-inner video {
          transform: scale(1.05);
        }

        .location-photo-placeholder {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: var(--cream);
          gap: 10px;
        }

        .location-photo-placeholder svg {
          opacity: 0.8;
        }

        .location-photo-placeholder span {
          font-size: 12px;
          letter-spacing: 3px;
          text-transform: uppercase;
          opacity: 0.9;
        }

        /* Location overlay label */
        .location-label {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 20px 15px 15px;
          background: linear-gradient(to top, rgba(58, 74, 92, 0.85) 0%, transparent 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }

        .location-label-icon {
          width: 16px;
          height: 16px;
          color: var(--cream);
          opacity: 0.9;
        }

        .location-label-text {
          font-family: 'Cormorant Garamond', serif;
          font-size: 16px;
          font-weight: 500;
          color: var(--cream);
          letter-spacing: 2px;
        }

        /* Decorative corners on location photo */
        .location-corner {
          position: absolute;
          width: 20px;
          height: 20px;
          border-color: var(--gold-light);
          border-style: solid;
          opacity: 0.6;
          z-index: 2;
        }

        .location-corner.top-left {
          top: 12px;
          left: 12px;
          border-width: 2px 0 0 2px;
        }

        .location-corner.top-right {
          top: 12px;
          right: 12px;
          border-width: 2px 2px 0 0;
        }

        .location-corner.bottom-left {
          bottom: 12px;
          left: 12px;
          border-width: 0 0 2px 2px;
        }

        .location-corner.bottom-right {
          bottom: 12px;
          right: 12px;
          border-width: 0 2px 2px 0;
        }

        /* Event Details */
        .event-details {
          text-align: center;
          margin-bottom: 35px;
          animation: fadeInUp 1s ease-out 0.8s both;
        }

        .event-date {
          font-family: 'Cormorant Garamond', serif;
          font-size: 28px;
          font-weight: 400;
          color: var(--dusty-blue-deeper);
          letter-spacing: 3px;
          margin-bottom: 8px;
        }

        .event-time {
          font-family: 'Josefin Sans', sans-serif;
          font-size: 20px;
          font-weight: 400;
          letter-spacing: 4px;
          color: var(--text-soft); /* Changed from gold for better visibility */
          margin-bottom: 20px;
        }

        .event-location {
          font-family: 'Cormorant Garamond', serif;
          font-size: 30px;
          font-weight: 500;
          color: var(--text-dark);
          margin-bottom: 5px;
        }

        /* ... existing address styles ... */
        .event-address {
          font-family: 'Josefin Sans', sans-serif;
          font-size: 16px;
          font-weight: 200;
          letter-spacing: 2px;
          color: var(--text-soft);
          transition: color 0.3s ease;
        }

        .event-address-link {
          text-decoration: none;
          display: inline-block;
        }

        .event-address-link:hover .event-address {
          color: var(--dusty-blue-deeper);
          text-decoration: underline;
        }

        /* Info Cards */
        .info-cards {
          display: flex;
          gap: 20px;
          margin-bottom: 40px;
          animation: fadeInUp 1s ease-out 0.9s both;
        }

        .timeline-section {
          width: 100%;
          max-width: 600px;
          margin-bottom: 50px;
          position: relative;
          animation: fadeInUp 1s ease-out 0.9s both;
          padding: 0 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .timeline-title {
          text-align: center;
          font-family: 'Cormorant Garamond', serif;
          font-size: 32px;
          font-style: italic;
          color: var(--text-dark);
          margin-bottom: 35px;
          position: relative;
          width: 100%;
        }
        
        /* Decorative underline for title */
        .timeline-title::after {
          content: '';
          display: block;
          width: 60%;
          height: 1px;
          background: var(--gold);
          margin: 5px auto 0;
        }

        .timeline-container {
          position: relative;
          padding: 20px 0;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        /* Vertical Thread Line */
        .timeline-container::before {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          left: 50%;
          width: 1px;
          background: linear-gradient(180deg, 
            transparent 0%, 
            var(--dusty-blue-deeper) 15%, 
            var(--dusty-blue-deeper) 85%, 
            transparent 100%
          );
          transform: translateX(-50%);
        }

        .timeline-row {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 35px;
          position: relative;
          width: 100%;
          min-height: 40px;
        }

        .timeline-col {
          flex: 0 0 50%;
          max-width: 50%;
          display: flex;
          flex-direction: column;
        }

        .timeline-col.left {
          text-align: right;
          padding-right: 25px;
          align-items: flex-end;
        }

        .timeline-col.right {
          text-align: left;
          padding-left: 25px;
          align-items: flex-start;
        }

        .timeline-marker {
          width: 14px;
          height: 14px;
          background: var(--gold);
          border: 3px solid var(--cream);
          border-radius: 50%;
          box-shadow: 0 0 0 1px var(--gold);
          z-index: 2;
          flex-shrink: 0;
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
          transition: transform 0.3s ease;
        }
        
        .timeline-row:hover .timeline-marker {
          transform: translate(-50%, 0) scale(1.3);
          background: var(--dusty-blue-deeper);
          box-shadow: 0 0 0 1px var(--dusty-blue-deeper);
        }

        .t-time {
          font-family: 'Josefin Sans', sans-serif;
          font-size: 16px;
          color: var(--dusty-blue-deeper);
          font-weight: 600;
          letter-spacing: 1px;
          line-height: 1.2;
        }

        .t-event {
          font-family: 'Cormorant Garamond', serif;
          font-size: 22px;
          color: var(--text-dark);
          font-style: italic;
          line-height: 1.1;
        }
        
        /* Mobile adjustments for timeline */
        @media (max-width: 580px) {
           .timeline-col.left { padding-right: 20px; }
           .timeline-col.right { padding-left: 20px; }
           .t-event { font-size: 18px; }
           .t-time { font-size: 14px; }
           .timeline-marker { width: 12px; height: 12px; }
        }

        /* Accommodation Section */
        .accommodation-section {
          width: 100%;
          max-width: 500px;
          margin-bottom: 40px;
          animation: fadeInUp 1s ease-out 0.95s both;
        }

        .accommodation-toggle {
          width: 100%;
          padding: 15px 20px;
          background: rgba(255, 255, 255, 0.6);
          border: 1px solid var(--dusty-blue);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          transition: all 0.3s ease;
          color: var(--text-dark);
          font-family: 'Josefin Sans', sans-serif;
          font-size: 14px;
          letter-spacing: 2px;
          text-transform: uppercase;
        }

        .accommodation-toggle:hover {
          background: rgba(255, 255, 255, 0.9);
          border-color: var(--dusty-blue-dark);
        }

        .accommodation-toggle.open {
          background: var(--cream);
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          border-bottom-color: transparent;
        }

        .accommodation-icon {
          color: var(--gold);
          transition: transform 0.3s ease;
        }

        .accommodation-toggle.open .accommodation-icon {
          transform: rotate(180deg);
        }

        .accommodation-content {
          background: var(--cream);
          border: 1px solid var(--dusty-blue);
          border-top: none;
          border-radius: 0 0 8px 8px;
          overflow: hidden;
          max-height: 0;
          opacity: 0;
          transition: all 0.5s ease-in-out;
        }

        .accommodation-content.open {
          max-height: 500px; /* Adjust based on content */
          opacity: 1;
          padding: 20px;
          box-shadow: 0 10px 20px rgba(195, 229, 234, 0.2);
        }

        .hotel-list {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .hotel-item {
          display: flex;
          flex-direction: column;
          padding-bottom: 15px;
          border-bottom: 1px solid var(--dusty-blue-light);
        }

        .hotel-item:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .hotel-header {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          margin-bottom: 5px;
        }

        .hotel-name {
          font-family: 'Cormorant Garamond', serif;
          font-size: 18px;
          font-weight: 500;
          color: var(--text-dark);
        }

        .hotel-dist {
          font-size: 12px;
          color: var(--gold);
          font-weight: 300;
        }

        .hotel-desc {
          font-size: 13px;
          color: var(--text-soft);
          font-weight: 300;
          line-height: 1.4;
          margin-bottom: 8px;
        }

        .hotel-link {
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: var(--dusty-blue-deeper);
          text-decoration: none;
          align-self: flex-start;
          transition: color 0.2s;
        }

        .hotel-link:hover {
          color: var(--dusty-blue-dark);
          text-decoration: underline;
        }

        .info-card {
          flex: 1;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 20px 25px;
          background: rgba(255, 255, 255, 0.8);
          border: 1.5px solid var(--dusty-blue);
          border-radius: 8px;
          backdrop-filter: blur(10px);
          box-shadow: 0 4px 15px rgba(195, 229, 234, 0.15);
        }

        .info-card-icon {
          width: 24px;
          height: 24px;
          color: var(--dusty-blue-dark);
          margin-bottom: 10px;
        }

        .info-card-label {
          font-size: 14px;
          font-weight: 300;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: var(--text-soft);
          margin-bottom: 5px;
        }

        .info-card-value {
          font-family: 'Cormorant Garamond', serif;
          font-size: 20px;
          font-weight: 500;
          color: var(--text-dark);
        }

        /* CTA Button */
        .cta-section {
          animation: fadeInUp 1s ease-out 1s both;
        }

        .cta-button {
          position: relative;
          padding: 18px 50px;
          font-family: 'Josefin Sans', sans-serif;
          font-size: 12px;
          font-weight: 300;
          letter-spacing: 5px;
          text-transform: uppercase;
          color: #ffffff;
          background: #8ac4d0;
          border: none;
          cursor: pointer;
          overflow: hidden;
          transition: all 0.4s ease;
          box-shadow: 0 10px 30px rgba(138, 196, 208, 0.4);
        }

        .cta-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
          transition: left 0.6s ease;
        }

        .cta-button:hover {
          transform: translateY(-3px);
          box-shadow: 0 15px 40px rgba(138, 196, 208, 0.6);
          background: linear-gradient(135deg, #7ab9c7 0%, #a8d5dd 100%);
        }

        .cta-button:hover::before {
          left: 100%;
        }

        .cta-button:active {
          transform: translateY(-1px);
        }

        /* Button decorative corners */
        .cta-button::after {
          content: '';
          position: absolute;
          top: 6px;
          left: 6px;
          right: 6px;
          bottom: 6px;
          border: 1px solid rgba(255,255,255,0.2);
          pointer-events: none;
        }

        /* Footer Note */
        .footer-note {
          margin-top: 40px;
          text-align: center;
          animation: fadeInUp 1s ease-out 1.1s both;
        }

        .footer-text {
          font-family: 'Cormorant Garamond', serif;
          font-size: 14px;
          font-style: italic;
          color: var(--text-soft);
          letter-spacing: 1px;
        }

        /* Responsive */
        @media (max-width: 580px) {
          .wedding-main {
            padding: 30px 15px;
          }

          .corner-decor {
            width: 80px;
            height: 80px;
          }

          .photo-frame {
            width: 180px;
            height: 180px;
          }

          .tulip-left, .tulip-right {
            display: none;
          }

          .names {
            font-size: 40px;
          }

          .ampersand {
            font-size: 26px;
          }

          .location-photo-frame {
            height: 235px;
          }

          .location-label-text {
            font-size: 14px;
          }

          .event-date {
            font-size: 24px;
          }

          .event-location {
            font-size: 24px;
          }

          .info-cards {
            flex-direction: column;
            gap: 15px;
            width: 100%;
          }

          .info-card {
            flex-direction: row;
            justify-content: flex-start;
            gap: 15px;
            padding: 15px 20px;
          }

          .info-card-icon {
            margin-bottom: 0;
          }

          .info-card-content {
            text-align: left;
          }

          .cta-button {
            padding: 16px 40px;
            font-size: 11px;
            letter-spacing: 4px;
          }
        }
      `}</style>

      <div className="wedding-main">
        <div className="bg-gradient" />

        {/* Floating Petals */}
        <div className="petals">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="petal" />
          ))}
        </div>

        {/* Corner Decorations */}
        {['top-left', 'top-right', 'bottom-left', 'bottom-right'].map((pos) => (
          <div key={pos} className={`corner-decor ${pos}`}>
            <svg viewBox="0 0 120 120" fill="none">
              <path d="M10 110 L10 40 Q10 10 40 10 L110 10" stroke="#c3e5ea" strokeWidth="1" />
              <circle cx="30" cy="30" r="5" fill="#f6cdca" />
              <path d="M10 70 Q30 60 40 40" stroke="#c3e5ea" strokeWidth="1" opacity="0.5" />
              <path d="M70 10 Q60 30 40 40" stroke="#c3e5ea" strokeWidth="1" opacity="0.5" />
              {/* Small tulip decoration */}
              <path d="M25 85 L25 70" stroke="#c3e5ea" strokeWidth="1" />
              <path d="M25 72 Q18 65 20 55 Q23 50 25 52 Q27 50 30 55 Q32 65 25 72" fill="#f6cdca" opacity="0.6" />
            </svg>
          </div>
        ))}

        <div className="save-the-date-card">
          <p className="header-text">Save the Date</p>

          {/* Photo Section */}
          <div className="photo-section">
            <div className="decorative-ring" />
            
            {/* Left Tulip */}
            <div className="tulip tulip-left">
              <svg width="60" height="120" viewBox="0 0 60 120">
                <path d="M30 120 L30 55" stroke="#c3e5ea" strokeWidth="2" />
                <path d="M30 60 Q12 42 18 18 Q24 0 30 6 Q36 0 42 6 Q48 0 48 18 Q54 42 30 60" fill="#f6cdca" />
                <path d="M30 60 L30 25" stroke="#c3e5ea" strokeWidth="1" opacity="0.4" />
                <path d="M32 85 Q50 78 55 60" stroke="#c3e5ea" strokeWidth="1.5" fill="none" />
                <path d="M32 85 Q45 80 55 60 Q42 75 32 85" fill="#f6cdca" opacity="0.5" />
              </svg>
            </div>

            {/* Right Tulip */}
            <div className="tulip tulip-right">
              <svg width="60" height="120" viewBox="0 0 60 120">
                <path d="M30 120 L30 55" stroke="#c3e5ea" strokeWidth="2" />
                <path d="M30 60 Q12 42 18 18 Q24 0 30 6 Q36 0 42 6 Q48 0 48 18 Q54 42 30 60" fill="#f6cdca" />
                <path d="M30 60 L30 25" stroke="#c3e5ea" strokeWidth="1" opacity="0.4" />
                <path d="M28 85 Q10 78 5 60" stroke="#c3e5ea" strokeWidth="1.5" fill="none" />
                <path d="M28 85 Q15 80 5 60 Q18 75 28 85" fill="#f6cdca" opacity="0.7" />
              </svg>
            </div>

            <div className="photo-frame">
              <div className="photo-inner">
                {fotoUrl ? (
                  <img src={fotoUrl} alt="Gli sposi" />
                ) : (
                  <div className="photo-placeholder">
                    <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Names */}
          <h1 className="names">
            {sposa}
            <span className="ampersand">&</span>
            {sposo}
          </h1>

          {/* Divider */}
          <div className="divider">
            <div className="divider-line" />
            <div className="divider-line" />
          </div>

          {/* Event Details */}
          <div className="event-details">
            <p className="event-date">{data}</p>
            <p className="event-time">ore {ora}</p>
            <p className="event-location">{location}</p>
            <a 
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(indirizzo)}`} 
              target="_blank" 
              rel="noopener noreferrer"
              className="event-address-link"
            >
              <p className="event-address">{indirizzo}</p>
            </a>
          </div>

           {/* Location Video Section */}
          <div className="location-section">
            
            <div className="location-photo-frame">
              <div className="location-photo-inner">
                <video 
                  src={videoLocationUrl} 
                  autoPlay 
                  loop 
                  muted 
                  playsInline
                  alt={location}
                />
                
                {/* Corner decorations */}
                <div className="location-corner top-left" />
                <div className="location-corner top-right" />
                <div className="location-corner bottom-left" />
                <div className="location-corner bottom-right" />
              </div>
            </div>
          </div>

          {/* Info Cards */}
          <div className="info-cards">
            <div className="info-card">
              <svg className="info-card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
              <div className="info-card-content">
                <p className="info-card-label">Ingresso</p>
                <p className="info-card-value">ore 11:30</p>
              </div>
            </div>
            <div className="info-card">
              <svg className="info-card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M18 8h1a4 4 0 0 1 0 8h-1" />
                <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
                <line x1="6" y1="1" x2="6" y2="4" />
                <line x1="10" y1="1" x2="10" y2="4" />
                <line x1="14" y1="1" x2="14" y2="4" />
              </svg>
              <div className="info-card-content">
                <p className="info-card-label">Ricevimento</p>
                <p className="info-card-value">A seguire</p>
              </div>
            </div>
          </div>

          {/* Timeline Section */}
          <div className="timeline-section">
            <h3 className="timeline-title">Il Programma</h3>
            <div className="timeline-container">
              
              {/* Item 1 */}
              <div className="timeline-row">
                <div className="timeline-col left">
                  <span className="t-time">11:30</span>
                </div>
                <div className="timeline-marker" />
                <div className="timeline-col right">
                  <span className="t-event">Benvenuto al Parco</span>
                </div>
              </div>

              {/* Item 2 */}
              <div className="timeline-row">
                <div className="timeline-col left">
                  <span className="t-time">A seguire</span>
                </div>
                <div className="timeline-marker" />
                <div className="timeline-col right">
                  <span className="t-event">Cerimonia al Teatro</span>
                </div>
              </div>

              {/* Item 3 */}
              <div className="timeline-row">
                <div className="timeline-col left">
                  <span className="t-time">A seguire</span>
                </div>
                <div className="timeline-marker" />
                <div className="timeline-col right">
                  <span className="t-event">Aperitivo in Terrazza</span>
                </div>
              </div>

              {/* Item 4 */}
              <div className="timeline-row">
                <div className="timeline-col left">
                  <span className="t-time">A seguire</span>
                </div>
                <div className="timeline-marker" />
                <div className="timeline-col right">
                  <span className="t-event">Pranzo in Limonaia</span>
                </div>
              </div>

            </div>
          </div>

          {/* Accommodation Section */}
          {hotels && hotels.length > 0 && (
            <div className="accommodation-section">
              <div 
                className={`accommodation-toggle ${isAccommodationOpen ? 'open' : ''}`}
                onClick={() => setIsAccommodationOpen(!isAccommodationOpen)}
              >
                <span>VUOI RIMANERE A DORMIRE?</span>
                <svg 
                  className="accommodation-icon" 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="1.5"
                >
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </div>
              <div className={`accommodation-content ${isAccommodationOpen ? 'open' : ''}`}>
                <ul className="hotel-list">
                  {hotels.map((hotel, index) => (
                    <li key={index} className="hotel-item">
                      <div className="hotel-header">
                        <span className="hotel-name">{hotel.nome}</span>
                        <span className="hotel-dist">{hotel.distanza}</span>
                      </div>
                      <p className="hotel-desc">{hotel.descrizione}</p>
                      {hotel.link && (
                        <a href={hotel.link} target="_blank" rel="noopener noreferrer" className="hotel-link">
                          Vedi Dettagli &rarr;
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}

          {/* CTA Button */}
          <div className="cta-section">
            <button 
              className="cta-button"
              onClick={onConferma}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              Conferma Partecipazione
            </button>
          </div>

          {/* Footer Note */}
          <div className="footer-note">
            <p className="footer-text">Vi aspettiamo per celebrare insieme il nostro amore</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;